




































































































































































import {
  defineComponent,
  computed,
  ref,
  useRouter,
  useRoute,
  watch,
} from "@nuxtjs/composition-api";
import { useConfigStore, useLuckyWheelStore } from "~/stores/extensionApi";
import { useUser } from "~/modules/customer/composables/useUser";
import { decodeUid, changeImage, checkHttpLink } from "~/helpers";
import { useTraverseCategory } from "~/modules/catalog/category/helpers/useTraverseCategory";
import { useClevertapStore } from "~/stores/clevertap";

export default defineComponent({
  name: "PopupFixtop",
  components: {},
  props: {
    isPopUp: {
      type: Object,
      default: () => null, // Use a function to return null
    },
    typePage: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const router = useRouter();
    const route = useRoute();
    const luckyWheelStore = useLuckyWheelStore();
    const configStore = useConfigStore();
    const { isAuthenticated, user: userCurrent, load: loadUser } = useUser();
    const { activeCategory } = useTraverseCategory();
    const clevertapStore = useClevertapStore();

    const pageId = ref(null);
    const imagePopupMobile = computed(() => {
      return props.isPopUp?.image_mobile
        ? changeImage(props.isPopUp.image_mobile)
        : "";
    });

    const getUserCheckWinWheel = computed(() => {
      return luckyWheelStore.getUserCheckWinWheel;
    });

    const countTime = computed(() => {
      return configStore.getCountDownTime?.data[0]?.count_down_time;
    });
    const popupFixTop = computed(() => configStore.getDataPopUpFixTop);

    const checkClose = ref(false);
    const checkWinWheel = ref(false);
    const cssFix = ref(
      '<style type="text/css">.site-header {top: 44px;}</style>'
    );
    const days1 = ref(null);
    const hours1 = ref(null);
    const minutes1 = ref(null);
    const seconds1 = ref(null);
    const days2 = ref(null);
    const hours2 = ref(null);
    const minutes2 = ref(null);
    const seconds2 = ref(null);

    const getTimeLeft = (until: number) => {
      return {
        seconds: Math.floor(until % 60),
        minutes: Math.floor(until / 60) % 60,
        hours: Math.floor(until / (60 * 60)) % 24,
        days: Math.floor(until / (60 * 60 * 24)),
      };
    };

    const checkIsCountDown = async () => {
      if (props.isPopUp?.is_countdown == 1 && isCountDown.value) {
        await configStore.getConfigPopupCountdown(props.isPopUp?.entity_id);
        countDownTime(countTime.value);
      }
    };

    const countDownTime = (times) => {
      if (times != 0) {
        setInterval(() => {
          times = times - 1;
          const { days, hours, minutes, seconds } = getTimeLeft(times);

          days1.value = solve(days)[0];
          days2.value = solve(days)[1];

          hours1.value = solve(hours)[0];
          hours2.value = solve(hours)[1];

          minutes1.value = solve(minutes)[0];
          minutes2.value = solve(minutes)[1];

          seconds1.value = solve(seconds)[0];
          seconds2.value = solve(seconds)[1];
        }, 1000);
      }
    };
    const solve = (number) => {
      // Kiểm tra số có 1 chữ số hay 2 chữ số
      const numberOfDigits = number.toString().length;

      // Nếu số có 1 chữ số thì trả về 0 và số đó
      if (numberOfDigits === 1) {
        return [0, number];
      }

      // Nếu số có 2 chữ số thì tách 2 số đó ra 2 số mới
      else {
        const tens = number % 10 == 0 ? number / 10 + 1 : number / 10;
        const units = number % 10;

        return [
          parseFloat(number?.toString()[0]),
          parseFloat(number?.toString()[1]),
        ];
      }
    };

    const screenForPopup = async () => {
      // Only proceed if props.isPopUp exists
      if (!props.isPopUp) {
        checkClose.value = false;
        return;
      }

      if (props.isPopUp?.game_codes) {
        luckyWheelStore.setGameCode(props.isPopUp.game_codes);

        if (!isAuthenticated.value) {
          checkWinWheel.value = false;
          checkPopUpNotWinWeel();
          return;
        } else {
          if (props.typePage == "HOME") {
            let phone = userCurrent.value?.phone_number;
            let data = {
              phone,
              game_codes: luckyWheelStore.getGameCodes,
            };

            let check = await luckyWheelStore.setInforWinWheel(data);
            if (check) {
              checkWinWheel.value = true;
            } else {
              checkWinWheel.value = false;
              checkPopUpNotWinWeel();
            }
          } else {
            checkWinWheel.value = false;
            checkPopUpNotWinWeel();
            return;
          }
        }
      } else {
        checkPopUpNotWinWeel();
      }
    };

    const isCountDown = computed(() => {
      const locationString = props.isPopUp?.location || "";
      let arr = locationString ? locationString.split(",") : [];
      if (arr.length === 0) {
        return false;
      }
      if (arr.includes("all_page")) {
        return true;
      }
      if (arr.includes("home") && props.typePage === "HOME") {
        return true;
      }
      if (
        arr.includes("category") &&
        props.typePage === "CATEGORY" &&
        pageId.value
      ) {
        const categoryIds = props.isPopUp?.category_ids || "";
        let categoryArr = categoryIds ? categoryIds.split(",") : [];
        if (categoryArr.includes(pageId.value.toString())) {
          return true;
        }
        return false;
      }
      return false;
    });

    const checkPopUpNotWinWeel = () => {
      checkWinWheel.value = false;
      const locationString = props.isPopUp?.location || "";
      let arr = locationString ? locationString.split(",") : [];

      if (arr && arr.length > 0) {
        arr.forEach((element) => {
          if (props.typePage === element.toUpperCase()) {
            checkCategory(element, props.isPopUp);
            checkLandingPage(element, props.isPopUp);
            checkProductDetail(element, props.isPopUp);
          }
          checkAnother(element, props.isPopUp);
        });
      }
    };

    const checkCategory = (element, dataPopUp) => {
      if (element.toUpperCase() === "CATEGORY") {
        const categoryIds = dataPopUp?.category_ids || "";
        let arr = categoryIds ? categoryIds.split(",") : [];
        let check = arr?.includes(pageId.value?.toString());
        let checkDataPopupAllPage = (dataPopUp?.location || "").includes(
          "all_page"
        );

        if (check || checkDataPopupAllPage) {
          checkClose.value = true;
        } else {
          checkClose.value = false;
        }
      }
    };

    const checkLandingPage = (element, dataPopUp) => {
      if (element.toUpperCase() === "LANDING") {
        const landingIds = dataPopUp?.landing_ids || "";
        let arr = landingIds ? landingIds.split(",") : [];
        let check = arr.filter((e) => e == pageId.value);
        let checkDataPopupAllPage = (dataPopUp?.location || "").includes(
          "all_page"
        );
        if ((check.length > 0 && check) || checkDataPopupAllPage) {
          checkClose.value = true;
        } else {
          checkClose.value = false;
        }
      }
    };

    const checkProductDetail = (element, dataPopUp) => {
      if (element.toUpperCase() == "PRODUCT") {
        const productIds = dataPopUp?.product_ids || "";
        let arr = productIds ? productIds.split(",") : [];
        let check = arr.filter((e) => e == pageId.value);
        let checkDataPopupAllPage = (dataPopUp?.location || "").includes(
          "all_page"
        );

        if ((check.length > 0 && check) || checkDataPopupAllPage) {
          checkClose.value = true;
        } else {
          checkClose.value = false;
        }
      }
    };

    const checkAnother = (element, dataPopUp) => {
      if (
        element.toUpperCase() != "CATEGORY" &&
        element.toUpperCase() != "LANDING" &&
        element.toUpperCase() != "PRODUCT"
      ) {
        const popupFixTopValue = popupFixTop.value || [];
        let checkDataPopupHome = popupFixTopValue.filter(
          (e) => (e.location || "").includes(element) === true
        );
        let checkDataPopupAllPage = (dataPopUp?.location || "").includes(
          "all_page"
        );

        if (checkDataPopupHome.length === 0 && checkDataPopupAllPage) {
          let check = popupFixTopValue.find(
            (e) => e.entity_id === dataPopUp?.entity_id
          );
          if (check) {
            checkClose.value = true;
          }
        }
        if (checkDataPopupHome.length > 0 && checkDataPopupAllPage) {
          let check = checkDataPopupHome.find(
            (e) => e.entity_id === dataPopUp?.entity_id
          );
          if (check) {
            checkClose.value = true;
          }
        }

        if (checkDataPopupHome.length > 0 && checkDataPopupAllPage) {
          let check = checkDataPopupHome.find(
            (e) => e.entity_id === dataPopUp?.entity_id
          );
          if (check) {
            checkClose.value = true;
            return;
          } else {
            let checkAll = popupFixTopValue.find(
              (e) => e.entity_id === dataPopUp?.entity_id
            );
            if (checkAll) {
              checkClose.value = true;
              return;
            }
          }
        }
      }
    };

    const trackPopupPromotion = () => {
      if (typeof window == "undefined" ) return;
      if (!props.isPopUp) return;
      const dataPopupPromotion = {
        promotion_name: props.isPopUp.name || "",
        promotion_id: props.isPopUp.entity_id || "popup_promotion",
      };

      if (window.clevertap) {
        clevertapStore.popupPromotionCleverTap({
          clevertap: window.clevertap,
          data: dataPopupPromotion,
        });
      }
    };

    watch(
      () => route.value,
      async () => {
        try {
          if (route.value?.path == "/") {
            pageId.value = 2;
          } else if (activeCategory.value) {
            pageId.value = activeCategory.value?.uid
              ? decodeUid(activeCategory.value.uid)
              : null;
          }

          if (props.isPopUp) {
            await screenForPopup();
            await checkIsCountDown();
          }
        } catch (error) {
          console.error("Error in route watch:", error);
          checkClose.value = false;
        }
      },
      { immediate: true }
    );

    watch(
      () => userCurrent.value,
      async (newVal, oldVal) => {
        try {
          if (newVal && props.isPopUp?.game_codes && newVal !== oldVal) {
            await screenForPopup();
            await checkIsCountDown();
          }
        } catch (error) {
          console.error("Error in userCurrent watch:", error);
          checkClose.value = false;
        }
      },
      { immediate: true }
    );

    watch(
      () => props.isPopUp,
      (newVal, oldVal) => {
        if (newVal && checkClose.value && !getUserCheckWinWheel.value) {
          trackPopupPromotion();
        }
      },
      { immediate: true }
    );

    return {
      checkClose,
      getUserCheckWinWheel,
      cssFix,
      changeImage,
      days1,
      hours1,
      minutes1,
      seconds1,
      days2,
      hours2,
      minutes2,
      seconds2,
      countTime,
      checkHttpLink,
      imagePopupMobile,
    };
  },

  head() {
    return {
      link: this.imagePopupMobile
        ? [
            {
              rel: "preload",
              as: "image",
              href: this.imagePopupMobile,
            },
          ]
        : [],
    };
  },
});
